@if (empty()) {
    <jhi-hyperion-empty [titleKey]="emptyTitleKey()" [descriptionKey]="emptyDescriptionKey()" data-testid="hyperion-files-empty" />
} @else {
    <div class="flex flex-col gap-4" data-testid="hyperion-file-change-list">
        @for (group of groups(); track group.repo) {
            <div class="min-w-0" [attr.data-repo]="group.repo">
                <p class="m-0 mb-1 flex items-baseline gap-2 text-sm font-semibold" [id]="group.labelId">
                    <span [jhiTranslate]="group.labelKey"></span>
                    <span class="text-sm font-normal text-muted-color tabular-nums">{{ group.count }}</span>
                </p>
                <ul class="m-0 flex list-none flex-col p-0" role="list" [attr.aria-labelledby]="group.labelId">
                    @for (row of group.rows; track row.key) {
                        <li class="min-w-0">
                            <div class="hyperion-artifact-row" [attr.data-recent]="row.recencyLabelKey ? '' : null" data-testid="hyperion-file-row">
                                <span class="flex min-w-0 flex-auto flex-col">
                                    <span class="font-medium break-all">{{ row.name }}</span>
                                    @if (row.directory) {
                                        <span class="truncate text-xs text-muted-color">{{ row.directory }}</span>
                                    }
                                    @if (row.recencyLabelKey) {
                                        <span class="text-xs text-muted-color" [jhiTranslate]="row.recencyLabelKey"></span>
                                    }
                                </span>
                                @if (row.actionLabelKey) {
                                    <tumaet-ui-tag class="shrink-0" severity="secondary" [value]="row.actionLabelKey | artemisTranslate" />
                                }
                            </div>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
}
